const SCORE_DIMENSIONS = [
	{ key: 'effort', icon: '♡', tone: 'coral' },
	{ key: 'flirt', icon: '✦', tone: 'pink' },
	{ key: 'concreteness', icon: '♨', tone: 'magenta' },
	{ key: 'politeness', icon: '◯', tone: 'violet' },
];

export const useScoreFactors = (scoreProgress, t) => {
	const factorRows = SCORE_DIMENSIONS.map((dimension) => ({
		...dimension,
		name: t.scoreDimensions?.[dimension.key] || dimension.key,
		value: Number(scoreProgress?.score?.[dimension.key]) || 0,
	}));
	const highestFactorScore = Math.max(1, ...factorRows.map((factor) => factor.value));

	return { factorRows, highestFactorScore };
};
